/**
 * Bold Options Conditional Logic
 * Handles conditional enabling/disabling of DORMOTION (DM) Soft-Close dropdown
 * based on Door Weight variant selection
 */

const BOC_LOG_PREFIX = '[BoldOptionsConditional]';
function bocLog(){ try { if (window && window.__BOC_DEBUG__ === true) console.debug(BOC_LOG_PREFIX, ...arguments); } catch(e){} }
try { window.__BOC_LOADED__ = true; if (window && window.__BOC_DEBUG__ === true) console.debug(BOC_LOG_PREFIX, 'script loaded'); } catch(_) {}
let BOC_INIT = { dorm: false, hand: false };

// Utility: unhide Bold containers that may be hidden via 'bold_hidden' class or inline styles
function bocUnhide(el) {
  try {
    if (!el) return;
    if (el.classList) el.classList.remove('bold_hidden');
    if (el.style) {
      try { el.style.removeProperty('display'); } catch(_) {}
      try { el.style.removeProperty('visibility'); } catch(_) {}
      try { el.style.removeProperty('opacity'); } catch(_) {}
    }
    let p = el.parentElement, i = 0;
    while (p && i < 4) {
      try {
        if (p.classList) p.classList.remove('bold_hidden');
        if (p.style && (p.style.display === 'none' || p.style.visibility === 'hidden')) {
          p.style.display = '';
          p.style.visibility = '';
        }
      } catch(_) {}
      p = p.parentElement;
      i++;
    }
  } catch(_) {}
}

document.addEventListener('DOMContentLoaded', function() {
  bocLog('DOMContentLoaded');
  initializeBoldOptionsConditional();
});

document.addEventListener('BOLD_OPTIONS_onload', function() {
  bocLog('BOLD_OPTIONS_onload');
  initializeBoldOptionsConditional();
});

function initializeBoldOptionsConditional() {
  let attempts = 0;
  const checkBoldOptions = setInterval(function() {
    attempts++;
    const dormotion = findDormotionOption();
    const handed = findHandedOption();
    const doorWeight = findDoorWeightVariant();
    bocLog('probe', { attempts, dormotionFound: !!dormotion, handedFound: !!handed, doorWeightFound: !!doorWeight });

    if (doorWeight && dormotion) {
      setupConditionalLogic(dormotion, doorWeight);
    }
    if (doorWeight && handed) {
      setupHandedLogic(handed, doorWeight);
    }

    // If Door Weight not ready yet but DORMOTION control exists, select "Added" immediately
    if (!doorWeight && dormotion && dormotion.select && dormotion.select.options) {
      try {
        const sel = dormotion.select;
        let idx = -1;
        for (let i = 0; i < sel.options.length; i++) {
          const opt = sel.options[i];
          const txt = String(opt.text || '').trim();
          const val = String(opt.value || '').trim();
          if (/^(?:Included)$/i.test(val) || (/^(?:Included)$/i.test(txt) && !/not/i.test(txt))) { idx = i; break; }
        }
        if (idx === -1 && sel.options.length) {
          // Fallback: first non-placeholder
          for (let i = 0; i < sel.options.length; i++) {
            const txt = String(sel.options[i].text || '').trim();
            if (txt && !/^[-–—]/.test(txt)) { idx = i; break; }
          }
        }
        if (idx >= 0 && sel.selectedIndex !== idx) {
          sel.selectedIndex = idx;
          sel.value = sel.options[idx].value;
          try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
        }
      } catch(e) { bocLog('boot-set Added for DM failed', e); }
    }

    if ((doorWeight && (dormotion || handed)) || attempts >= 100) {
      clearInterval(checkBoldOptions);
    }
  }, 150);

  // Re-wire whenever Bold updates its DOM
  document.addEventListener('BOLD_OPTIONS_update', function() {
    try {
      const d = findDormotionOption();
      const h = findHandedOption();
      const w = findDoorWeightVariant();
      if (w && d) setupConditionalLogic(d, w);
      if (w && h) setupHandedLogic(h, w);
    } catch (e) { bocLog('rewire on BOLD_OPTIONS_update failed', e); }
  });
}

function findDormotionOption() {
  // Helper: visible test (avoid hidden clones)
  const isVisible = (el) => {
    try {
      if (!el) return false;
      if (el.offsetParent !== null) return true;
      const cs = window.getComputedStyle ? getComputedStyle(el) : null;
      return !!cs && cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
    } catch(_) { return true; }
  };

  // 1) Try direct select match first, but prefer visible
  let directMatches = Array.from(document.querySelectorAll('select[name="properties[DORMOTION (DM) Soft-Close]"], select[name="properties[DORMOTION]"]'));
  if (directMatches.length) {
    // Prefer visible
    let visible = directMatches.find(s => isVisible(s) && isVisible(s.closest('.bold_option') || s.closest('.bold-options__option') || s.parentElement));
    let sel = visible || directMatches[0];
    const container = sel.closest('.bold_option') || sel.closest('.bold-options__option') || sel.parentElement;
    bocLog('found DORMOTION via name', { visible: !!visible });
    return { select: sel, container };
  }

  // 2) Search containers by label text, support select, radios, or checkbox. Prefer visible.
  const containers = Array.from(document.querySelectorAll('.bold_options .bold_option, .bold-options__option, .bold_option'));
  const dmContainers = containers.filter(c => {
    const labelEl = c.querySelector('.bold_option_title, label, .bold_option_value_title, .bold_option_product_title');
    const labelText = (labelEl?.innerText || '').toUpperCase();
    return labelText.includes('DORMOTION') || (labelText.includes('DM') && labelText.includes('SOFT-CLOSE'));
  });

  // Prefer visible container
  let container = dmContainers.find(isVisible) || dmContainers[0];

  if (container) {
    const selects = Array.from(container.querySelectorAll('select'));
    const visibleSelect = selects.find(isVisible) || selects[0];
    if (visibleSelect) {
      bocLog('found DORMOTION select via label', { visible: !!(selects.find(isVisible)) });
      return { select: visibleSelect, container };
    }
    const radios = Array.from(container.querySelectorAll('input[type="radio"]'));
    if (radios.length) {
      const visibleRadios = radios.filter(isVisible);
      bocLog('found DORMOTION radios via label', { count: radios.length, visibleCount: visibleRadios.length });
      return { inputs: (visibleRadios.length ? visibleRadios : radios), container };
    }
    const checkbox = container.querySelector('input[type="checkbox"]');
    if (checkbox) {
      bocLog('found DORMOTION checkbox via label');
      return { inputs: [checkbox], container };
    }
  }

  // 3) Final fallback: any select inside labeled containers (even if hidden)
  for (const c of dmContainers) {
    const sel = c.querySelector('select');
    if (sel) return { select: sel, container: c };
  }

  return null;
}
 
function findHandedOption() {
  // Try direct name match first (Bold properties)
  let selectElement = document.querySelector('select[name="properties[Handed]"]');
  // Search by container label text as fallback (handles selects or radios)
  if (!selectElement) {
    const containers = document.querySelectorAll('.bold_option, .bold-options__option');
    for (const container of containers) {
      const labelEl = container.querySelector('.bold_option_title, label, .bold_option_value_title, .bold_option_product_title');
      const labelText = (labelEl?.innerText || '').toUpperCase();
      if (labelText.includes('HANDED')) {
        const sel = container.querySelector('select') || container.querySelector('input, textarea');
        bocLog('found HANDED via container label', {labelText});
        return { select: sel, container };
      }
    }
    // Fallback: scan selects within Bold containers
    const candidates = document.querySelectorAll('.bold_options .bold_option select, .bold_options select, .bold_option select, .bold-options__option select');
    for (const sel of candidates) {
      const container = sel.closest('.bold_option') || sel.closest('.bold-options__option') || sel.parentElement;
      const labelEl = container?.querySelector('.bold_option_title, label, .bold_option_value_title, .bold_option_product_title');
      const labelText = (labelEl?.innerText || '').toUpperCase();
      if (labelText.includes('HANDED')) {
        bocLog('found HANDED select via label', {labelText});
        return { select: sel, container };
      }
    }
  }
  if (selectElement) {
    const container = selectElement.closest('.bold_option') || selectElement.closest('.bold-options__option') || selectElement.parentElement;
    bocLog('found HANDED via name');
    return { select: selectElement, container };
  }
  return null;
}
 
function findDoorWeightVariant() {
  // PageFly dropdown (original option named "Weight" but labeled "Door Weight")
  let el = document.querySelector('select.pf-variant-select[data-option-name="Weight"]');
  if (!el) {
    el = document.querySelector('select.pf-variant-select[data-option-name="Door Weight"]');
  }

  if (!el) {
    // Standard Shopify variant selects
    const variantSelects = document.querySelectorAll('.product-form__input select, variant-selects select, select[name^="options["]');
    for (const sel of variantSelects) {
      const wrap = sel.closest('.product-form__input') || sel.parentElement;
      const lbl = wrap?.querySelector('label, legend');
      const txt = (lbl?.textContent || '').toUpperCase();
      if (txt.includes('DOOR WEIGHT') || txt === 'WEIGHT' || txt.includes('WEIGHT')) {
        el = sel; break;
      }
    }
  }

  // Radios by explicit names
  if (!el) {
    const radios = document.querySelectorAll('input[type="radio"][name="Weight"], input[type="radio"][name="Door Weight"]');
    if (radios.length) return radios;
  }

  // Radios via generic options[...] name + legend/label match
  if (!el) {
    const fieldsets = document.querySelectorAll('fieldset, .product-form__input');
    for (const fs of fieldsets) {
      const legendOrLabel = fs.querySelector('legend, label');
      const txt = (legendOrLabel?.textContent || '').toUpperCase();
      if (txt.includes('DOOR WEIGHT') || txt === 'WEIGHT' || txt.includes('WEIGHT')) {
        const radios = fs.querySelectorAll('input[type="radio"][name^="options["]');
        if (radios.length) return radios;
        // As a fallback, a select inside this group
        const sel = fs.querySelector('select[name^="options["]');
        if (sel) { el = sel; break; }
      }
    }
  }

  if (!el) {
    // Bold as variant property (unlikely)
    el = document.querySelector('select[name="properties[Door Weight]"], select[name="properties[Weight]"]');
  }
  bocLog('door weight element', {found: !!el, isNodeList: !!(el && typeof el.length === 'number')});
  return el;
}

function setupConditionalLogic(dormotionOption, doorWeightSelect) {
  // Ensure DM shows "Added" by default (supports select, radios, checkbox)
  const setDormotionToAdded = () => {
    // Prefer exact value/text "Added" (screenshot shows option value="Added")
    let changed = false;
    const CANDIDATES = [
      /^(?:added)$/i,        // exact "Added"
      /^(?:yes|include|included)$/i,
      /added/i,
      /yes/i,
      /include/i
    ];

    if (dormotionOption.select && dormotionOption.select.options) {
      const sel = dormotionOption.select;
      let targetIndex = -1;

      // 1) Exact value/text "Added"
      for (let i = 0; i < sel.options.length; i++) {
        const opt = sel.options[i];
        const txt = String(opt.text || '').trim();
        const val = String(opt.value || '').trim();
        if (/^(?:included)$/i.test(val) || (/^(?:included)$/i.test(txt) && !/not/i.test(txt))) {
          targetIndex = i; break;
        }
      }

      // 2) Fallback to candidate patterns
      if (targetIndex === -1) {
        for (let i = 0; i < sel.options.length; i++) {
          const opt = sel.options[i];
          const txt = String(opt.text || '').trim();
          const val = String(opt.value || '').trim();
          if (CANDIDATES.some(rx => rx.test(val) || rx.test(txt)) && !/not/i.test(val) && !/not/i.test(txt)) {
            targetIndex = i; break;
          }
        }
      }

      // 3) As last resort, first non-placeholder option
      if (targetIndex === -1 && sel.options.length) {
        for (let i = 0; i < sel.options.length; i++) {
          const txt = String(sel.options[i].text || '').trim();
          if (txt && !/^[-–—]/.test(txt)) { targetIndex = i; break; }
        }
      }

      if (targetIndex !== -1 && sel.selectedIndex !== targetIndex) {
        sel.selectedIndex = targetIndex;
        for (let j = 0; j < sel.options.length; j++) {
        const o = sel.options[j];
        const isSel = (j === targetIndex);
        o.selected = isSel;
        try { isSel ? o.setAttribute('selected','selected') : o.removeAttribute('selected'); } catch(_) {}
        try { o.setAttribute('aria-selected', isSel ? 'true' : 'false'); } catch(_) {}
      }
        // Keep value in sync for libs that look at element.value
        sel.value = sel.options[targetIndex].value;
        changed = true;
      }

      // Notify only if selection actually changed
      if (changed) {
        try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
      }
      return changed;
    }

    // Radio/checkbox support (if DM ever configured that way)
    if (Array.isArray(dormotionOption.inputs) && dormotionOption.inputs.length) {
      let target = null;
      dormotionOption.inputs.forEach(inp => {
        const val = String(inp.value || inp.getAttribute('data-value') || '').trim();
        let labelTxt = '';
        try {
          const lab = document.querySelector('label[for="' + inp.id + '"]');
          labelTxt = (lab?.textContent || '').trim();
        } catch (_) {}
        if (!target && (CANDIDATES.some(rx => rx.test(val)) || CANDIDATES.some(rx => rx.test(labelTxt))) && !/not/i.test(val) && !/not/i.test(labelTxt)) {
          target = inp;
        }
      });
      if (!target) target = dormotionOption.inputs[0];
      if (target && !target.checked) { target.checked = true; changed = true; }
      const dispatchEl = target || dormotionOption.inputs[0];
     if (changed && dispatchEl) {
       try { dispatchEl.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
     }
     return changed;
    }

    return changed;
  };
 
  // Enable/disable any DM inputs inside the container (select/radios/checkbox)
  const setDisabledForDMInputs = (container, disabled) => {
    if (!container) return;
    const inputs = container.querySelectorAll('select, input, textarea, button');
    inputs.forEach(el => {
      el.disabled = !!disabled;
      if (disabled) {
        el.setAttribute('aria-disabled','true');
      } else {
        el.removeAttribute('aria-disabled');
      }
      try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
    });
  };
 
   const getSelectedWeightText = () => {
    if (!doorWeightSelect) return '';
    if (NodeList.prototype.isPrototypeOf(doorWeightSelect)) {
      let val = '';
      doorWeightSelect.forEach(r => { if (r.checked) val = r.value || r.getAttribute('data-value') || ''; });
      return (val || '').trim();
    } else {
      const selIdx = doorWeightSelect.selectedIndex;
      const txt = doorWeightSelect.options?.[selIdx]?.text || '';
      if (txt) return txt.trim();
      return (doorWeightSelect.value || '').trim();
    }
  };

  const unhide = function(el) {
  try {
    if (!el) return;
    if (el.classList) el.classList.remove('bold_hidden');
    if (el.style) el.style.display = '';
    let p = el.parentElement, i = 0;
    while (p && i < 3) {
      try {
        if (p.classList) p.classList.remove('bold_hidden');
        if (p.style && p.style.display === 'none') p.style.display = '';
      } catch(_) {}
      p = p.parentElement;
      i++;
    }
  } catch(_) {}
};
  const updateDormotionState = function() {
    const upper = (getSelectedWeightText() || '').toUpperCase();
    // Detect 150 kg / 330 lb (or code XL150)
    const is150 = /\b(?:XL)?150\b/.test(upper) || /150\s*KG|330\s*LB/.test(upper);

    if (is150) {
      // Enable and default to Added (user may choose otherwise)
      setDormotionToAdded();
      if (dormotionOption.select) {
        dormotionOption.select.disabled = false;
        dormotionOption.select.removeAttribute('aria-disabled');
      }
      if (Array.isArray(dormotionOption.inputs)) {
        dormotionOption.inputs.forEach(el => { el.disabled = false; el.removeAttribute('aria-disabled'); });
      }
      if (dormotionOption.container) {
        dormotionOption.container.classList.remove('disabled','bold-options--disabled');
        dormotionOption.container.style.opacity = '1';
        dormotionOption.container.style.pointerEvents = 'auto';
        dormotionOption.container.style.display = '';
      }
    } else {
      // Force Added and disable control for 120/80
      setDormotionToAdded();
      if (dormotionOption.select) {
        dormotionOption.select.disabled = true;
        dormotionOption.select.setAttribute('aria-disabled','true');
      }
      if (Array.isArray(dormotionOption.inputs)) {
        dormotionOption.inputs.forEach(el => { el.disabled = true; el.setAttribute('aria-disabled','true'); });
      }
      if (dormotionOption.container) {
        dormotionOption.container.classList.add('disabled','bold-options--disabled');
        dormotionOption.container.style.opacity = '0.5';
        dormotionOption.container.style.pointerEvents = 'none';
        dormotionOption.container.style.display = '';
        setDisabledForDMInputs(dormotionOption.container, true);
      }
    }
    const dispatchEl = dormotionOption.select || (dormotionOption.inputs && dormotionOption.inputs[0]);
    try { dispatchEl && dispatchEl.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
  };

  // Initial apply (repeat to win over Bold re-render timing)
  updateDormotionState();
  setTimeout(updateDormotionState, 150);
  setTimeout(updateDormotionState, 500);

  // Listeners
  if (NodeList.prototype.isPrototypeOf(doorWeightSelect)) {
    doorWeightSelect.forEach(r => r.addEventListener('change', updateDormotionState));
  } else {
    doorWeightSelect.addEventListener('change', updateDormotionState);
  }
  document.addEventListener('variant:changed', function(){ setTimeout(updateDormotionState, 100); });
  document.addEventListener('BOLD_OPTIONS_update', function(){ setTimeout(updateDormotionState, 100); });
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function(){ setTimeout(updateDormotionState, 0); });
    }
  } catch(e) { bocLog('subscribe variantChange attach failed (DM)', e); }
}

/**
 * Handed visibility controller
 * - Hide for 150 kg / 330 lb and 80 kg / 176 lb
 * - Show ONLY for 120 kg / 264 lb
 */
function setupHandedLogic(handedOption, doorWeightSelect) {
  const getSelectedWeightText = () => {
    if (!doorWeightSelect) return '';
    if (NodeList.prototype.isPrototypeOf(doorWeightSelect)) {
      let val = '';
      doorWeightSelect.forEach(r => {
        if (r.checked) {
          val = r.value || r.getAttribute('data-value') || '';
          if (!val) {
            try {
              const lab = document.querySelector('label[for="' + r.id + '"]');
              const node = lab && (lab.querySelector('.swatch__label, .value, span, strong') || lab);
              const txt = node ? node.textContent : '';
              if (txt) val = txt;
            } catch(_) {}
          }
        }
      });
      return (val || '').trim();
    } else {
      const idx = doorWeightSelect.selectedIndex;
      const txt = doorWeightSelect.options?.[idx]?.text || '';
      if (txt) return txt.trim();
      return (doorWeightSelect.value || '').trim();
    }
  };

  const setDisabledForInputs = (container, disabled) => {
    if (!container) return;
    const inputs = container.querySelectorAll('select, input, textarea, button');
    inputs.forEach(el => {
      el.disabled = !!disabled;
      if (disabled) {
        el.setAttribute('aria-disabled','true');
        if (el.tagName === 'SELECT') el.selectedIndex = 0;
        if (el.type === 'radio' || el.type === 'checkbox') el.checked = false;
      } else {
        el.removeAttribute('aria-disabled');
      }
      try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
    });
  };

  const updateHandedState = function() {
    const upper = (getSelectedWeightText() || '').toUpperCase();
    const is150 = /\b(?:XL)?150\b/.test(upper) || /150\s*KG|330\s*LB/.test(upper);
    const is80  = /\b(?:XL|L)?80\b/.test(upper)  || /80\s*KG|176\s*LB/.test(upper);
    const is120 = /\b(?:XL)?120\b/.test(upper) || /\bM120\b/.test(upper) || /120\s*KG|264\s*LB/.test(upper);
    const show = !!is120;
    const container = handedOption?.container || handedOption?.select?.closest('.bold_option') || handedOption?.select?.closest('.bold-options__option') || handedOption?.select?.parentElement;

    bocLog('Handed update', { is150, is80, is120, show });

    if (show) {
      if (container) {
        try { bocUnhide(container); } catch(_) {}
        container.style.display = '';
        container.classList.remove('bold-options--disabled','disabled','bold_hidden');
        container.style.opacity = '';
        container.style.pointerEvents = '';
      }
      setDisabledForInputs(container, false);
    } else {
      if (container) {
        container.style.display = 'none';
      }
      setDisabledForInputs(container, true);
    }
  };

  // Initial apply
  updateHandedState();

  // Listeners
  if (NodeList.prototype.isPrototypeOf(doorWeightSelect)) {
    doorWeightSelect.forEach(r => r.addEventListener('change', updateHandedState));
  } else {
    doorWeightSelect.addEventListener('change', updateHandedState);
  }
  document.addEventListener('variant:changed', function(){ setTimeout(updateHandedState, 100); });
  document.addEventListener('BOLD_OPTIONS_update', function(){ setTimeout(updateHandedState, 100); });
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function(){ setTimeout(updateHandedState, 0); });
    }
  } catch(e) { bocLog('subscribe variantChange attach failed (handed)', e); }
}

 
// Observe dynamic content
const observer = new MutationObserver(function(mutations) {
  for (const m of mutations) {
    if (m.addedNodes && m.addedNodes.length) {
      const dormotionOption = findDormotionOption();
      const handedOption = findHandedOption();
      const doorWeightSelect = findDoorWeightVariant();
      if (doorWeightSelect && (dormotionOption || handedOption)) {
        bocLog('Mutation observer hooked elements');
        // observer.disconnect();
        if (dormotionOption) setupConditionalLogic(dormotionOption, doorWeightSelect);
        if (handedOption) setupHandedLogic(handedOption, doorWeightSelect);
        break;
      }
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
/* Fallback/enforcer removed to prevent performance issues */